import { isNil } from 'lodash-es';

/**
 * Generates CSS for applying a border radius to an element.
 *
 * @param options - Options for the mixin.
 */ function borderRadius(options) {
    if (typeof options === 'string') return borderRadius({
        radius: options
    });
    const { radius, radiusBottom, radiusLeft, radiusRight, radiusTop, radiusTopLeft, radiusTopRight, radiusBottomRight, radiusBottomLeft } = options;
    return (theme)=>[
            !isNil(radius) ? {
                borderRadius: radius && theme.borderRadiuses[radius]
            } : undefined,
            !isNil(radiusBottom) ? {
                borderBottomRightRadius: radiusBottom && theme.borderRadiuses[radiusBottom],
                borderBottomLeftRadius: radiusBottom && theme.borderRadiuses[radiusBottom]
            } : undefined,
            !isNil(radiusLeft) ? {
                borderBottomLeftRadius: radiusLeft && theme.borderRadiuses[radiusLeft],
                borderTopLeftRadius: radiusLeft && theme.borderRadiuses[radiusLeft]
            } : undefined,
            !isNil(radiusRight) ? {
                borderBottomRightRadius: radiusRight && theme.borderRadiuses[radiusRight],
                borderTopRightRadius: radiusRight && theme.borderRadiuses[radiusRight]
            } : undefined,
            !isNil(radiusTop) ? {
                borderTopLeftRadius: radiusTop && theme.borderRadiuses[radiusTop],
                borderTopRightRadius: radiusTop && theme.borderRadiuses[radiusTop]
            } : undefined,
            !isNil(radiusTopLeft) ? {
                borderTopLeftRadius: radiusTopLeft && theme.borderRadiuses[radiusTopLeft]
            } : undefined,
            !isNil(radiusTopRight) ? {
                borderTopRightRadius: radiusTopRight && theme.borderRadiuses[radiusTopRight]
            } : undefined,
            !isNil(radiusBottomRight) ? {
                borderBottomRightRadius: radiusBottomRight && theme.borderRadiuses[radiusBottomRight]
            } : undefined,
            !isNil(radiusBottomLeft) ? {
                borderBottomLeftRadius: radiusBottomLeft && theme.borderRadiuses[radiusBottomLeft]
            } : undefined
        ];
}
/**
 * Parses a border radius token into a CSS value.
 */ function parseBorderRadius(theme, radius) {
    return radius && theme.borderRadiuses[radius];
}

export { borderRadius, parseBorderRadius };
//# sourceMappingURL=border-radius.js.map
